import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { getAllBlogPosts } from "../../../methods/blog/blogRequests";
import BlogComponent from "../../../components/blog/BlogComponent";
import { Link } from "react-router-dom";

export function Search() {
  return (
    <FormControl sx={{ width: { xs: "100%", md: "25ch" } }} variant="outlined">
      <OutlinedInput
        size="small"
        id="search"
        placeholder="Search…"
        sx={{ flexGrow: 1 }}
        startAdornment={
          <InputAdornment position="start" sx={{ color: "text.primary" }}>
            <SearchRoundedIcon fontSize="small" />
          </InputAdornment>
        }
        inputProps={{
          "aria-label": "search",
        }}
      />
    </FormControl>
  );
}

export default function MainContent() {
  const [blogPosts, setBlogPosts] = React.useState([]);

  React.useEffect(() => {
    getBlogPosts();
  }, []);

  const getBlogPosts = async () => {
    const response = await getAllBlogPosts();
    if (response.success) {
      setBlogPosts(response.data);
    } else {
      setBlogPosts(null);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <div>
        <Typography variant="h1" gutterBottom>
          Blog
        </Typography>
        <Typography>
          Stay in the loop with the latest about our products
        </Typography>
      </div>
      <Box
        sx={{
          display: { xs: "flex", sm: "none" },
          flexDirection: "row",
          gap: 1,
          width: { xs: "100%", md: "fit-content" },
          overflow: "auto",
        }}
      ></Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "row" },
          width: "100%",
          justifyContent: "space-between",
          alignItems: { xs: "start", md: "center" },
          gap: 4,
          overflow: "auto",
        }}
      ></Box>
      <Grid container spacing={2}>
        {blogPosts.length > 0 &&
          blogPosts.map((blog) => (
            <Grid size={6}>
              <Link to={`/blog/${blog.id}`}>
                <BlogComponent key={blog.id} cardData={blog} />
              </Link>
            </Grid>
          ))}
      </Grid>
    </Box>
  );
}
